import CancelIcon from "src/components/CancelIcon";
import { Form, Input, Button, Switch, Card, Row, Col } from "antd";
import { useEffect, useRef, useState } from "react";
import { AudioGenerateComponent } from "src/modules/worksheet/components/WorksheetEditor/components/Modals/AudioGenerateComponent";
const { TextArea } = Input;
const FormItem = Form.Item;

export const VideoInsertComponent = (props: any) => {
    const { onChange, onDelete, value } = props;
    const inputRef = useRef<any>();

    useEffect(() => {
        inputRef.current.focus();
    }, []);

    // Solving Caret Jumping in React Inputs
    const [val, setVal] = useState(value);
    const [config, setConfig] = useState(props.config ?? {});
    const updateVal = (val: any) => {
        /* Make update synchronous, to avoid caret jumping when the value doesn't change asynchronously */
        setVal(val);
        /* Make the real update afterwards */
        onChange({ video: val, config });
    };
    const updateConfig = (type, value) => {
        setConfig((prev: any) => {
            onChange({ video: val, config: { ...prev, [type]: value } });
            return { ...prev, [type]: value };
        });
    };

    return (
        <Card>
            <Form layout={"inline"} component={false}>
                <Row gutter={12}>
                    <Col span={12}>
                        <FormItem
                            label={"Video Url"}
                            className="video-insert-form-item"
                        >
                            <TextArea
                                placeholder="type/paste video"
                                value={val}
                                onChange={(e) => updateVal(e.target.value)}
                                ref={inputRef}
                                autoSize
                            />
                        </FormItem>
                    </Col>

                    <Col span={12}>
                        <FormItem label={"Limit reached msg"}>
                            <TextArea
                                value={config.restrict_play_msg}
                                onChange={(e) =>
                                    updateConfig(
                                        "restrict_play_msg",
                                        e.target.value,
                                    )
                                }
                                autoSize
                            />
                        </FormItem>

                        <h3>Limit Reached Audio</h3>
                        <AudioGenerateComponent
                            name={"Limit Reached Audio"}
                            onSave={(data: any) => {
                                updateConfig("audio", data);
                            }}
                            audioData={config?.audio}
                        />
                    </Col>

                    <Col span={12}>
                        <FormItem label="Max Play limit">
                            <Input
                                value={config.max_play_limit}
                                onChange={(e) =>
                                    updateConfig(
                                        "max_play_limit",
                                        e.target.value,
                                    )
                                }
                                type="number"
                            />
                        </FormItem>
                    </Col>

                    <Col span={12}>
                        <FormItem label="Try again Max Play limit">
                            <Input
                                value={config.try_again_max_play_limit}
                                onChange={(e) =>
                                    updateConfig(
                                        "try_again_max_play_limit",
                                        e.target.value,
                                    )
                                }
                                type="number"
                            />
                        </FormItem>
                    </Col>

                    <Col span={12}>
                        <Form.Item label="Show Controls">
                            <Switch
                                checked={config.show_controls}
                                onChange={(value) =>
                                    updateConfig("show_controls", value)
                                }
                            />
                        </Form.Item>
                    </Col>

                    <Col span={12}>
                        {/* <FormItem className="video-insert-form-item">
                            <Button
                                type="primary"
                                shape="circle"
                                icon={<Save />}
                                style={{ padding: "2px" }}
                                onClick={() => {onChange(video);}}
                            />
                            </FormItem> */}

                        <FormItem
                            className="video-insert-form-item"
                            style={{ marginLeft: "10px" }}
                        >
                            <CancelIcon
                                isButton={true}
                                onClick={() => {
                                    onDelete();
                                }}
                            />
                        </FormItem>
                    </Col>
                </Row>
            </Form>
        </Card>
    );
};
